import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MobileService } from '@klickdata/core/mobile';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import { filter, map, takeUntil, tap } from 'rxjs/operators';
interface Breadcrumb {
    label: string;
    url: string;
}
@Component({
    selector: 'app-breadcrumb-routers',
    templateUrl: './breadcrumb-routers.component.html',
    styleUrls: ['./breadcrumb-routers.component.scss'],
})
export class BreadcrumbRoutersComponent extends OnDestroyHandler implements OnInit, AfterViewInit {
    breadcrumbs: Breadcrumb[] = [];

    constructor(private router: Router, private route: ActivatedRoute, private mobile: MobileService) {
        super();
    }

    ngOnInit(): void {
        this.breadcrumbs = this.buildBreadcrumb(this.route.root);
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => this.buildBreadcrumb(this.route.root)),
                takeUntil(this.destroy)
            )
            .subscribe((breadcrumbs) => {
                this.breadcrumbs = breadcrumbs;
            });
    }

    private buildBreadcrumb(route: ActivatedRoute, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
        const children: ActivatedRoute[] = route.children;

        if (children.length === 0) {
            return breadcrumbs;
        }

        for (const child of children) {
            const routeURL: string = child.snapshot.url.map((segment) => segment.path).join('/');
            if (routeURL !== '') {
                url += `/${routeURL}`;
            }

            const label = child.snapshot.data['breadcrumb'];
            if (label) {
                breadcrumbs.push({ label, url });
            }

            return this.buildBreadcrumb(child, url, breadcrumbs);
        }

        return breadcrumbs;
    }
    ngAfterViewInit() {
        this.mobile
            .isMobile()
            .pipe(
                takeUntil(this.destroy),
                filter((res) => !!res)
            )
            .subscribe(() =>
                setTimeout(() => {
                    window.scrollTo({
                        top: 33,
                    });
                })
            );
    }
}
